export default __webpack_public_path__ + "static/media/totaluserpic.087aa949.svg";